import { useEffect, useState } from "react";
import apiClient from '../../../../services/apiClient';
import { useMemo } from "react";
import { useParams } from "react-router-dom";

//const { eventId } = useParams();

function Payments({ eventId }) {
  const [paymentData, setPaymentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [PaymentTitle, setPaymentTitle] = useState(null);
 const [eventDate, setEventDate] = useState(null); // ✅ Store event date

  // Fetch event details
  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        const eventRes = await apiClient.get(
          `/event/${eventId}`
        );

        if (eventRes.data?.events) {
          const event = eventRes.data.events;
          setEventDate(event?.date || null); // ✅ Save event date
        }
      } catch (error) {
        console.error("Error loading event details:", error);
      }
    };

    if (eventId) {
      fetchEventDetails();
    }
  }, [eventId]);

  useEffect(() => {
  const fetchPayments = async () => {
    try {
    const [invoiceRes, proposalRes] = await Promise.allSettled([
  apiClient.post(`/payment-schedule/`, { event_id: eventId }),
  apiClient.post(`/payment-schedule-proposals/`, { event_id: eventId })
]);

const invoiceData = invoiceRes.status === 'fulfilled' ? invoiceRes.value.data : {};
const proposalData = proposalRes.status === 'fulfilled' ? proposalRes.value.data : {};

const useInvoiceCode = invoiceRes.status === 'fulfilled';

// Merge and map codes
const matchedItems = [
  ...(invoiceData.matched_items || []),
  ...(proposalData.matched_items || [])
].map(item => ({
  ...item,
  code: useInvoiceCode ? item.code : item.invoicecode
}));

const res = {
  data: {
    matched_items: matchedItems,
    title: invoiceData.title || proposalData.title || ''
  }
};




      setPaymentData(res.data.matched_items); // or whatever state you’re using
      setPaymentTitle(res.data.title);

    } catch (error) {
      console.error("Error fetching payment schedule:", error);
    }
    setLoading(false);
  };

  fetchPayments();
}, []);


  const renderStatusBadge = (dueDateStr, status) => {
    if (status === "PAID") {
      return (
        <td>
          <div className="alert alert-success">PAID</div>
        </td>
      );
    }

    if (!dueDateStr) {
      return (
        <td>
          <div className="alert alert-secondary">No Due Date</div>
        </td>
      );
    }

    const dueDate = new Date(dueDateStr);
    const today = new Date();

    dueDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (dueDate.getTime() === today.getTime()) {
      return (
        <td>
          <div className="alert alert-warning">DUE TODAY</div>
        </td>
      );
    }

    if (dueDate < today) {
      return (
        <td>
          <div className="alert alert-danger">OVERDUE</div>
        </td>
      );
    }

    if (dueDate > today) {
      return (
        <td>
          <div className="alert alert-primary">UPCOMING</div>
        </td>
      );
    }

    return (
      <td>
        <div className="alert alert-secondary">Unknown</div>
      </td>
    );
  };

  return (
    <>
      <div className="container-fluid p-lg-5 p-md-5 p-4 bg-white">
        <div className="row">
          {!paymentData ? (
            <div className="col-lg-11 col-md-11 mx-auto text-center payment_tab">
              <span>
                Send an invoice or proposal with a do-able payment schedule by
                clicking on the "send customer" button. Then, track payments
                with the help of reminders so everyone's always on the same
                page.
              </span>
            </div>
          ) : (
            <div className="col-lg-11 col-md-11 mx-auto">
              <h4>{PaymentTitle || "Event Proposal"}</h4>
              <h5 className="mt-3">Payment Schedule</h5>

              {loading ? (
                <div className="text-center py-4">Loading...</div>
              ) : (
                <div className="mt-4 table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="amou_nt">AMOUNT</th>
                        <th className="amou_nt">DUE DATE</th>
                        <th className="amou_nt">PAYMENT DATE</th>
                        <th className="amou_nt">PAYMENT ID</th>
                        <th className="amou_nt">STATUS</th>
                      </tr>
                    </thead>
                  <tbody>
  {paymentData.length === 0 ? (
    <tr>
      <td colSpan="5" className="text-center">
        No payments found
      </td>
    </tr>
  ) : (
    paymentData.map((item, index) => {
      const firstDate = eventDate
        ? new Date(eventDate) // assume ISO UTC string
        : new Date();

      // Step 2: Calculate the actual due date (UTC-safe)
      let actualDueDate;
      if (item.payment?.type === "smartdate") {
        let baseDate = new Date(firstDate.getTime()); 
        const days = parseInt(item.payment.smartdays ?? 0);
        const direction = item.payment.smartdirection || item.payment.dueDate || item.payment.paymentId || '';
        const isBefore = direction.includes("before");

        switch (item.payment.timetype?.toLowerCase()) {
          case "day(s)":
            baseDate.setUTCDate(
              baseDate.getUTCDate() +
                (isBefore ? -days : days)
            );
            break;
          case "week(s)":
            baseDate.setUTCDate(
              baseDate.getUTCDate() +
                (isBefore ? -days * 7 : days * 7)
            );
            break;
          case "month(s)":
            baseDate.setUTCMonth(
              baseDate.getUTCMonth() +
                (isBefore ? -days : days)
            );
            break;
          default:
            break;
        }

        actualDueDate = baseDate.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
          timeZone: "UTC", // Force UTC
        });
      } else {
        actualDueDate = item.due_date
          ? new Date(item.due_date).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
              timeZone: "UTC",
            })
          : "No Due Date";
      }

      return (
        <tr key={index}>
          <td>${item.payment?.amount != null ? (Number(item.payment.amount) || 0).toFixed(2) : "-"}</td>
          <td>{actualDueDate}</td>
          <td>
            {item.payment_log && item.payment_log.paid_at
              ? new Date(item.payment_log.paid_at).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                  timeZone: "UTC",
                })
              : "Not Paid"}
          </td>
          <td>{String(item.paymentId ?? '').startsWith('PAY-') ? item.paymentId : (item.code ?? "No ID")}</td>
          {renderStatusBadge(actualDueDate, item.status)}
        </tr>
      );
    })
  )}
</tbody>

                  </table>
                </div>
              )}

              <div className="d-flex justify-content-end py-4">
                <button
                  type="button"
                  className="btn btn-primary rounded-pill px-4 py-2"
                >
                  VIEW INVOICE
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export { Payments };
